import { Fragment, useRef } from "react";
import * as StateLib from "@/Utils/StateLib";
import { Menu, ToolIcon } from "@theorgchartdev/storybook";
import { getHoverTipContent } from "@/Utils/Misc";
import { BuildBranchStyleOptions } from "../ToolbarOptions";
import { ReRenderCanvas } from "@/Utils/StateLib";
import { enumBranchStyle, enumUpdateProperty } from "@coreapp/constants";
import { appstr } from "@coreapp/utils/appstr";
import { GetEnumString } from "@coreapp/utils/GetEnumString";
import { SubChartOptionEnable } from "@coreapp/utils/SubChartOptionEnable";
import { editModeTestId } from "@/appComponents/Navigation/RightSidebar/Utils/chartModeTestId";

const InsertSubchartBreak = () => {
  let wsMgr = StateLib.GetWSMgr();
  let canvasPanel = wsMgr.fCanvasPanel;
  if (!canvasPanel) return;
  canvasPanel.InsertSubChartBreak();
  ReRenderCanvas();
};
const RemoveSubchartBreak = () => {
  let wsMgr = StateLib.GetWSMgr();
  let canvasPanel = wsMgr.fCanvasPanel;
  if (!canvasPanel) return;
  canvasPanel.RemoveSubChartBreak();
  ReRenderCanvas();
};

export const UpdateBranchStyle = target => {
  let wsMgr = StateLib.GetWSMgr();
  const newBS = enumBranchStyle[target.value];
  wsMgr.ExtendBSSelection(newBS);
  let canvasPanel = wsMgr.fCanvasPanel;
  if (canvasPanel.ValidBranchStyleChange(newBS)) {
    canvasPanel.TagSelectedIntoAutoSmartGroup();
    StateLib.UpdateBoxProperty(enumUpdateProperty.branchStyle, newBS);
  }
};

const BranchToolsComposite = () => {
  const branchStyleOpenCtrlRef = useRef(null);
  let branchStyle;
  let wsMgr = StateLib.GetWSMgr();
  if (wsMgr) {
    branchStyle = wsMgr.SurveySelection(enumUpdateProperty.branchStyle);
  }
  let branchStyleTrigger = (
    <ToolIcon
      name={"network-wired-regular"}
      title={appstr("branchstyles")}
      tooltipProps={{
        ...getHoverTipContent("branchstyles"),
        referenceOpenCtrlRef: branchStyleOpenCtrlRef
      }}
    />
  );

  let branchStyleOptions = BuildBranchStyleOptions(UpdateBranchStyle);

  return (
    <Fragment>
      <ToolIcon
        id={"ctb-ins-break-btn"}
        name={"arrow-down-from-dotted-line"}
        title={appstr("Insert break")}
        onClick={InsertSubchartBreak}
        disabled={!SubChartOptionEnable(wsMgr).fEnableInsertBreak}
        tooltipProps={getHoverTipContent("insertsubchart")}
        dataTestId={editModeTestId("insert-break-btn")}
      />
      <ToolIcon
        id={"ctb-rm-break-btn"}
        name={"arrow-up-from-dotted-line"}
        title={appstr("Remove break")}
        onClick={RemoveSubchartBreak}
        disabled={!SubChartOptionEnable(wsMgr).fEnableRemoveBreak}
        tooltipProps={getHoverTipContent("removesubchart")}
        dataTestId={editModeTestId("remove-break-btn")}
      />
      <Menu
        openCtrlRef={branchStyleOpenCtrlRef}
        id={"ctb-brstyle-menu"}
        listProps={{ grid: true, gridCols: 4 }}
        value={GetEnumString(branchStyle)}
        options={branchStyleOptions}
        trigger={branchStyleTrigger}
        dataTestId={editModeTestId("branch-style-menu")}
      />
    </Fragment>
  );
};

export default BranchToolsComposite;
